<!--============================
=            IMAGES            =
=============================-->

<template>
  <!-- IMAGES CARDS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Images</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Contain and Cover
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container fluid>
              <v-row justify="space-around">
                <v-col cols="5">
                  <div class="title mb-1">Default (cover)</div>
                  <div class="subheading">Matching</div>
                  <v-img src="../../assets/img/bg/1.jpg" aspect-ratio="1.7"></v-img>
                  <div class="subheading pt-4">Too high</div>
                  <v-img src="../../assets/img/bg/3.jpg" aspect-ratio="2"></v-img>
                  <div class="subheading pt-4">Too low</div>
                  <v-img src="../../assets/img/bg/2.jpg" aspect-ratio="1.4"></v-img>
                </v-col>

                <v-col cols="5">
                  <div class="title mb-1">Contain</div>
                  <div class="subheading">Matching</div>
                  <v-img src="../../assets/img/bg/1.jpg" aspect-ratio="1.7" contain></v-img>
                  <div class="subheading pt-4">Too high</div>
                  <v-img src="../../assets/img/bg/1.jpg" aspect-ratio="2" contain></v-img>
                  <div class="subheading pt-4">Too low</div>
                  <v-img src="../../assets/img/bg/1.jpg" aspect-ratio="1.4" contain></v-img>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </base-card>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Gradients
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container fluid>
              <v-slider v-model="width" min="200" max="500" step="1"></v-slider>
              <v-navigation-drawer :width="width" :value="true" stateless>
                <v-img :aspect-ratio="16/9" src="../../assets/img/bg/1.jpg">
                  <v-row align="end" class="lightbox white--text pa-2 fill-height">
                    <v-col>
                      <div class="subheading">Jonathan Lee</div>
                      <div class="body-1">heyfromjonathan@gmail.com</div>
                    </v-col>
                  </v-row>
                </v-img>

                <v-list>
                  <template v-for="(item, i) in items">
                    <v-divider v-if="item.divider" :key="i"></v-divider>
                    <v-list-item v-else :key="item.title">
                      <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-list>
              </v-navigation-drawer>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Fixed ratio
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-row align="center" justify="center">
              <v-img
                src="https://bad.src/not/valid"
                lazy-src="https://picsum.photos/id/11/100/60"
                aspect-ratio="1"
                class="grey lighten-2"
                max-width="500"
                max-height="300"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-row>
          </div>
        </base-card>
      </v-col>

      <!-- IMAGES  -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            height
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-container class="fill-height" fluid style="min-height: 434px">
              <v-fade-transition mode="out-in">
                <v-row v-if="show" key="0">
                  <v-col cols="6">
                    <v-card>
                      <v-img src="../../assets/img/bg/1.jpg" height="125" class="grey darken-4"></v-img>
                      <v-card-title class="title">height</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="6">
                    <v-card>
                      <v-img
                        src="../../assets/img/bg/1.jpg"
                        height="125"
                        contain
                        class="grey darken-4"
                      ></v-img>
                      <v-card-title class="title">height with contain</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="6">
                    <v-card>
                      <v-img
                        src="https://picsum.photos/350/165?random"
                        max-height="125"
                        class="grey darken-4"
                      ></v-img>
                      <v-card-title class="title">max-height</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="6">
                    <v-card>
                      <v-img
                        src="https://picsum.photos/350/165?random"
                        max-height="125"
                        contain
                        class="grey darken-4"
                      ></v-img>
                      <v-card-title class="title">max-height with contain</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row v-else key="1" justify="center">
                  <v-btn text @click="show = true">Load images</v-btn>
                </v-row>
              </v-fade-transition>
            </v-container>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Grid
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-row>
              <v-col cols="12" sm="6" offset-sm="3">
                <v-card>
                  <v-container fluid>
                    <v-row>
                      <v-col v-for="n in 9" :key="n" class="d-flex child-flex" cols="4">
                        <v-card flat tile class="d-flex">
                          <v-img
                            :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                            :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                          >
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data: () => ({
    show: false,
    width: 300,
    items: [
      { icon: "inbox", title: "Inbox" },
      { icon: "star", title: "Starred" },
      { icon: "send", title: "Sent mail" },
      { icon: "drafts", title: "Drafts" },
      { divider: true },
      { icon: "mail", title: "All mail" },
      { icon: "delete", title: "Trash" },
      { icon: "error", title: "Spam" }
    ]
  })
};
</script>
<style scoped >
.v-navigation-drawer {
  transition: none !important;
}

.lightbox {
  box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.4) 0%,
    transparent 72px
  );
}
</style>

<!--====  End of IMAGES  ====-->
